import 'COMMON';
import 'jquery-validation';
import 'Vendor/maskedinput/maskedinput';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import { oSelectbox } from 'Lib/selectbox/selectbox';
import 'Bem/site/radio/radio';
import 'Bem/site/fileinput/fileinput';
import 'Bem/site/manuscript-form/manuscript-form';
import 'Bem/site/services-author/services-author';
import 'Bem/site/checkbox/checkbox';

svgSpriteLoader('/landing/manuscript-form/svg/sprite.svg?v=20180920');
oSelectbox.init('.selectbox');